export enum Action {
  Manage = 'manage',
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
  Complete = 'complete',
}

export enum ChangeChannelAction {
  SET_CHANNEL_NAME = 'SetChannelName',
  SET_CHANNEL_SHUNT_NUMBER = 'SetChannelShuntNumber',
  SET_CHANNEL_MACHINE_NUMBER = 'SetChannelMachineNumber',
  SET_CHANNEL_PHASE_NUMBER = 'SetChannelPhaseNumber',
  SET_CHANNEL_CURRENT_SCALING = 'SetChannelCurrentScaling',
  SET_CHANNEL_MAXIMUM_CHANNEL_TEMPERATURE = 'SetChannelMaximumChannelTemperature',
  SET_CHANNEL_TRIM_CHANNEL_SETPOINT = 'SetChannelTrimChannelSetpoint',
  SET_CHANNEL_POWER_SCALE = 'SetChannelPowerScale',
  SET_CHANNEL_TC_ASSIGN = 'SetChannelTCAssign',
  SET_CHANNEL_TC_REMOVE = 'SetChannelTCRemove',
  RESET_CHANNEL_SETPOINT = 'ResetChannelSetpoint',
  RESET_CHANNEL_FAULTS = 'ResetChannelFaults',
  CLEAR_CHANNEL_SETPOINT_ADJUST = 'ClearChannelSetpointAdjust',
  STOP_CHANNEL = 'StopChannel',
  START_CHANNEL = 'StartChannel',
  PAUSE_CHANNEL = 'PauseChannel',
  UNPAUSE_CHANNEL = 'UnpauseChannel',
  SET_CHANNEL_OUTPUT_CHANGE = 'SetChannelOutputChange',
  TEST_CHANNEL = 'TestChannel',
}

export enum ChangeControllerSettingsAction {
  SET_COOLING_SPREAD_CONTROL = 'SetCoolingSpreadControl',
  PID_GAINS_CHANGE_P = 'PidGainsChangeP',
  PID_GAINS_CHANGE_I = 'PidGainsChangeI',
  PID_GAINS_CHANGE_D = 'PidGainsChangeD',
  SET_SHUNT_TRIP = 'SetShuntTrip',
  RESET_TC_ASSIGNEMENTS = 'ResetTcAssignements',
  RESET_FAULT = 'ResetFault',
  FACTORY_RESET = 'FactoryReset',
  CLEAR_ALL_CHANNELS_NAMES = 'ClearAllChannelNames',

  //power sharing
  POWER_SHARING_ENABLE = 'EnablePowerSharing',
  POWER_SHARING_AMPERAGE = 'PowerSharingAmperage',
  FULL_POWER_ALLOWING = 'FullPowerAllowing',
  PRE_HEAT_RUN_WITH_FAULT = 'PreHeatRunWithFault',
  CHANNEL_CONSOLE_4_6 = 'ChannelConsole4x6',
  CHANNEL_CONSOLE_2_12 = 'ChannelConsole2x12',
  CHANNEL_CONSOLE_1_18 = 'ChannelConsole1x18',
  CHANNEL_CONSOLE_1_12_GEN = 'ChannelConsole1x12Gen',
}

export enum CycleSettingAction {
  SET_MODE_TO_PREHEAT = 'SetModeToPreheat',
  SET_MODE_TO_POST_WELD = 'SetModeToPostWeld',
  SET_MODE_TO_RECORDER = 'SetModeToRecorder',
  SET_MODE_TO_PERCENTAGE_TIMER = 'SetModeToPercentageTimer',
  SET_PREHEAT_RATE = 'SetPreheatRate',
  SET_PREHEAT_HOLDING_TEMPERATURE = 'SetPreheatHoldingTemperature',
  SET_PREHEAT_UPPER_HOLD_TOLERANCE = 'SetPreheatUpperHoldTolerance',
  SET_PREHEAT_LOWER_HOLD_TOLERANCE = 'SetPreheatLowerHoldTolerance',
  SET_PERCENTAGE_TIMER = 'SetPercentageTimer',
  SET_RECIPE_NAME = 'SetRecipeName',
  SET_RECIPE_RATE_UPPER_TOLERANCE = 'SetRecipeRateUpperTolerance',
  SET_RECIPE_RATE_LOWER_TOLERANCE = 'SetRecipeRateLowerTolerance',
  SET_RECIPE_HOLD_UPPER_TOLERANCE = 'SetRecipeHoldUpperTolerance',
  SET_RECIPE_HOLD_LOWER_TOLERANCE = 'SetRecipeHoldLowerTolerance',
  SET_RECIPE_ADD_STEP = 'SetRecipeAddStep',
  SET_RECIPE_REMOVE_STEP = 'SetRecipeRemoveStep',
  SET_RECIPE_CHANGE_STEP = 'SetRecipeChangeStep',
  SET_RECIPE_CHANGE_STEPS = 'SetRecipeChangeSteps',
  SET_CYCLE_CURRENT_STEP = 'SetCycleCurrentStep',
  SET_CYCLE_SKIP_TO_NEXT_STEP = 'SetCycleSkipToNextStep',
  SET_CYCLE_SKIP_TO_PREV_STEP = 'SetCycleSkipToPrevStep',
  SET_CYCLE_UPDATE_WHOLE_RECIPE = 'SetCycleUpdateWholeRecipe',
  SET_CYCLE_UPDATE_WHOLE_PRE_HEAT = 'SetCycleUpdateWholePreHeat',
}
